import "./Master.scss";
import { useHistory } from "react-router-dom";
import { Button, Content, DateInput, FormFields, usePathFactory, useTranslator } from "@sia/style-guide";
import Page from "../../../Page";
import { useContext, useEffect, useState } from "react";
import webPlatformAdapter from "common/Adapters/WebPlatformAdapter/WebPlatformAdapter";
import GlobalContext from "contexts/GlobalContext";

const MasterPage = () => {
  const translate = useTranslator();
  const pathFactory = usePathFactory();
  const history = useHistory();
  const { user, wizardSession } = useContext(GlobalContext);
  const [masterDate, setMasterDate] = useState(wizardSession?.masterGraduationDate || "");
  const [dateError, setDateError] = useState(null);
  useEffect(() => {
    let userId = user.siaId;
    webPlatformAdapter.getWizardSession(userId, (session) => {
      let masterGraduationDate = session?.masterGraduationDate;
      if (masterGraduationDate) {
        setMasterDate(masterGraduationDate);
      }
    });
  }, [user.siaId]);
  return (
    <Page>
      <Content width={"slim"} centeredTitle={true} centeredTexts={true}>
        <div className="master-page">
          <h1 className="productive-heading-04 master-page__heading">{translate("wizard.sia-ways.title")}</h1>
          <FormFields>
            <DateInput
              value={masterDate}
              required={true}
              label={translate("wizard.master.input.label")}
              id={"master-date"}
              onChange={(event, value, error) => {
                setMasterDate(value);
                setDateError(error);
              }}
              className={"master-page__input"}
              invalidPatternText={translate("form.input.error.invalid.with-example", { example: "d.m.yyyy" })}
              invalidText={dateError}
            />
          </FormFields>
          <p>
            <Button
              onClick={() => {
                if (!masterDate) {
                  return;
                }
                let sessionObject = { ...wizardSession, masterGraduationDate: masterDate };
                webPlatformAdapter.setWizardSession(user.userId, sessionObject);
                history.push(pathFactory.create("wizard/member-options"));
              }}
            >
              {translate("wizard.sia-ways.to-login.button.label")}
            </Button>
          </p>
        </div>
      </Content>
    </Page>
  );
};

export default MasterPage;
